import { render } from "./AddPetPage.vue?vue&type=template&id=55f99fc0&scoped=true"
import script from "./AddPetPage.vue?vue&type=script&lang=js"
export * from "./AddPetPage.vue?vue&type=script&lang=js"

import "./AddPetPage.vue?vue&type=style&index=0&id=55f99fc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f99fc0"]])

export default __exports__